/** Thrown when the browser can't draw on a canvas; the game's error card explains it. */
export class CanvasUnsupportedError extends Error {
  constructor() {
    super("This browser can't draw on a canvas");
    this.name = "CanvasUnsupportedError";
  }
}

/** Canvas games call this once when they mount, so an unsupported browser gets a message, not a blank field. */
export function requireCanvas(): true {
  let ok = false;
  try {
    ok = !!document.createElement("canvas").getContext("2d");
  } catch {
    ok = false;
  }
  if (!ok) throw new CanvasUnsupportedError();
  return true;
}
